function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "js.svg",
    transform: "matrix(5.27906,0,0,5.27906,85.1186,59.7481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-12,-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    style: {
      fill: "rgb(247,223,30)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.43,17.62C15.84,18.29 16.35,18.76 17.3,18.76C18.06,18.76 18.57,18.38 18.57,17.84C18.57,17.21 18.07,16.95 17.21,16.6L16.73,16.38C15.36,15.81 14.48,15.08 14.48,13.56C14.48,12.16 15.56,11.08 17.21,11.08C18.41,11.08 19.27,11.49 19.91,12.58L18.44,13.52C18.1,12.95 17.74,12.73 17.21,12.73C16.67,12.73 16.31,13.08 16.31,13.53C16.31,14.1 16.67,14.32 17.49,14.67L17.94,14.86C19.56,15.56 20.44,16.26 20.44,17.81C20.44,19.49 19.11,20.44 17.34,20.44C15.59,20.44 14.44,19.59 13.9,18.51L15.43,17.61L15.43,17.62ZM8.79,17.78C9.08,18.32 9.37,18.76 10,18.76C10.63,18.76 11.02,18.51 11.02,17.59L11.02,11.17L12.89,11.17L12.89,17.59C12.89,19.56 11.75,20.44 10.09,20.44C8.881,20.507 7.752,19.81 7.27,18.7L8.79,17.78Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.c21d181a77c17b888caf3e6d5a67ac20.svg";
export { ForwardRef as ReactComponent };